import { createContext, useContext } from "react";
import type DashboardLayoutStore from "./DashboardLayoutStore";

export type CardLayout = {
    layoutStore: DashboardLayoutStore;
    /** The dashboard is in arrange mode. */
    isEditing: boolean;
    /** Arrange mode, and the viewport is wide enough to drag and resize. */
    canArrange: boolean;
};

/**
 * Gives cards rendered by the dashboard grid access to its layout. Null
 * outside the grid, where cards neither measure themselves nor show a grip.
 */
export const CardLayoutContext = createContext<CardLayout | null>(null);

export const useCardLayout = () => useContext(CardLayoutContext);
